var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',{key:_vm.name,attrs:{"id":'accordion' + _vm.name}},[_c('v-expansion-panel-header',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-expansion-panel-content',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }